import { BoardScene } from "./../BoardScene";
import { BoardManager } from "./../BoardManager";
import { AdversaryContainer } from "./player-container/AdversaryContainer";
import { GameConstants } from "../../../GameConstants";
import { DeckContainer } from "./DeckContainer";
import { GameVars } from "../../../GameVars";
import { PlayerContainer } from "./player-container/PlayerContainer";
import { Bus } from "./Bus";
import { GameManager } from "../../../GameManager";
import { AudioManager } from "../../../AudioManager";

export class BoardContainer extends Phaser.GameObjects.Container {

    public static currentInstance: BoardContainer;

    public static POSITION_START = [0, 5, 10, 15];

    public static POSITION_STOP = [19, 4, 9, 14];

    public static POSITION_STOP_BUTTON = [
        {x: 0, y: 159, id: 10},
        {x: -270, y: 0, id: 7},
        {x: 0, y: -156, id: 4},
        {x: 270, y: 0, id: 1}
        
    ];

    public static POSITION_BUS = [
        {x: -140, y: 145, id: 10}, // 0
        {x: -220, y: 145, id: 9},
        {x: -245, y: 130, id: 8},
        {x: -270, y: 115, id: 7},
        {x: -270, y: 0, id: 7}, // stop 1
        {x: -270, y: -40, id: 7}, // 1
        {x: -270, y: -138, id: 6},
        {x: -245, y: -153, id: 5},
        {x: -220, y: -168, id: 4},
        {x: 0, y: -168, id: 4}, // stop 2
        {x: 62, y: -168, id: 4}, // 2
        {x: 220, y: -168, id: 3},
        {x: 245, y: -153, id: 2},
        {x: 270, y: -138, id: 1},
        {x: 270, y: 0, id: 1}, // stop 3
        {x: 270, y: 40, id: 1}, // 3
        {x: 270, y: 115, id: 12},
        {x: 245, y: 130, id: 11},
        {x: 220, y: 145, id: 10},
        {x: 0, y: 145, id: 10} // stop 0
    ];

    public deckContainer: DeckContainer;
    public playerContainer: PlayerContainer;
    public adversariesContainer: AdversaryContainer[];

    public bus: Bus;
    public stop: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        BoardContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        const boardBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "bg_1");
        this.add(boardBackground);

        this.stop = new Phaser.GameObjects.Image(this.scene, BoardContainer.POSITION_BUS[BoardContainer.POSITION_STOP[0]].x, BoardContainer.POSITION_BUS[BoardContainer.POSITION_STOP[0]].y, "texture_atlas_language", "stop");
        this.stop.visible = false;
        this.add(this.stop);

        this.adversariesContainer = [];

        for (let i = 1; i < 4; i++) {
            let adversaryContainer = new AdversaryContainer(this.scene, i);
            this.add(adversaryContainer);
            this.adversariesContainer.push(adversaryContainer);
        }

        this.playerContainer = new PlayerContainer(this.scene);
        this.add(this.playerContainer);

        this.bus = new Bus(this.scene);
        this.add(this.bus);

        this.deckContainer = new DeckContainer(this.scene);
        this.add(this.deckContainer);
        
    }

    public startGame(): void {
        
        for (let i = 0; i < this.adversariesContainer.length; i++) {
            this.adversariesContainer[i].startGame();
        }
        this.playerContainer.startGame();
        this.deckContainer.startGame();
    }

    public nextTurn(): void {

        let time = this.moveBus();

        if (GameVars.needStop !== -1) {
            this.stop.visible = true;
            this.stop.setPosition(BoardContainer.POSITION_STOP_BUTTON[GameVars.needStop].x, BoardContainer.POSITION_STOP_BUTTON[GameVars.needStop].y);
        } else {
            this.stop.visible = false;
        }

        this.scene.time.addEvent({ delay: time, callback: () => {

            AudioManager.stopSound();

            if (GameVars.currentTurn === 0) {

                if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 10) {
                    BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_2);
                    GameVars.tutorialCount = 11;
                }

                this.deckContainer.enableInputs();
                this.playerContainer.showStop();
            } else {

                if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 8) {
                    BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_7);
                    GameVars.tutorialCount = 9;
                } else {
                    BoardManager.selectAdversaryCard();
                }
                
            }
        }, callbackScope: this});
    }

    public moveBusToStop(): void {

        let time = this.bus.moveBusTo(BoardContainer.POSITION_STOP[GameVars.currentTurn]);

        this.scene.time.addEvent({ delay: time, callback: () => {
            AudioManager.stopSound();
        }, callbackScope: this});
    }

    public moveBus(): number {

        return this.bus.moveBusTo(BoardContainer.POSITION_START[GameVars.currentTurn]);
    }

    public showScores(): void {

        // show score
        this.scene.time.addEvent({ delay: 500, callback: () => {
            this.bringToTop(this.playerContainer);
            this.playerContainer.showScores();
        }, callbackScope: this});
        
        for (let i = 0; i < 3; i++) {

            if (GameVars.players[i + 1].tokens === 0 && GameVars.removePlayer !== i + 1) {
                continue;
            }

            this.scene.time.addEvent({ delay: 1000 + 1000 * i, callback: () => {
                this.bringToTop(this.adversariesContainer[i]);
                this.adversariesContainer[i].showScores();
            }, callbackScope: this});
        }

        // show positions
        for (let i = 0; i < GameVars.players.length; i++) {

            if (GameVars.players[i].tokens === 0 && GameVars.removePlayer !== i) {
                continue;
            }

            this.scene.time.addEvent({ delay: 5000 + GameVars.players[i].position * 500, callback: () => {
                if (i === 0) {
                    this.playerContainer.showPosition();
                } else {
                    this.adversariesContainer[i - 1].showPosition();
                }
            }, callbackScope: this});
        }

        if (GameVars.gameData.showTutorial && (GameVars.tutorialCount === 12 || GameVars.tutorialCount === 13 || GameVars.tutorialCount === 14)) {
            this.scene.time.addEvent({ delay: 9000, callback: () => {
                if (GameVars.lastPosition === 4) {
                    BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_4_2);
                } else {
                    BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_4_1);
                }
                GameVars.tutorialCount = 15;
            }, callbackScope: this});
        } else {

            // show points / remove positions / remove tokens
            for (let i = 0; i < GameVars.players.length; i++) {

                if (GameVars.players[i].tokens === 0 && GameVars.removePlayer !== i) {
                    continue;
                }
                
                this.scene.time.addEvent({ delay: 9000 + (GameVars.lastPosition - GameVars.players[i].position) * 500, callback: () => {
                    if (i === 0) {
                        this.playerContainer.showPoints();
                        this.playerContainer.hidePosition();
                        this.playerContainer.hideScores();
                    } else {
                        this.adversariesContainer[i - 1].showPoints();
                        this.adversariesContainer[i - 1].hidePosition();
                        this.adversariesContainer[i - 1].hideScores();
                    }
                }, callbackScope: this});
            }

            // new hand
            this.scene.time.addEvent({ delay: 13000, callback: () => {

                if (GameVars.removePlayer !== -1) {
                    GameVars.numPlayers--;
                    if (GameVars.removePlayer === 0) {
                        BoardScene.currentInstance.endGame(GameConstants.END_LOSE);
                        return;
                    } else {
                        this.adversariesContainer[GameVars.removePlayer - 1].removePlayer();
                    }
                }

                if (GameVars.numPlayers === 1) {
                    BoardScene.currentInstance.endGame(GameConstants.END_WIN);
                    return;
                }

                GameVars.removePlayer = -1;
                
                this.bringToTop(this.bus);
                this.bringToTop(this.deckContainer);
                BoardManager.allCardsToDeck();
            }, callbackScope: this});
        }
    }

    public showPoints(): void {

        // show points / remove positions / remove tokens
        for (let i = 0; i < GameVars.players.length; i++) {

            if (GameVars.players[i].tokens === 0 && GameVars.removePlayer !== i) {
                continue;
            }
            
            this.scene.time.addEvent({ delay: (GameVars.lastPosition - GameVars.players[i].position) * 500, callback: () => {
                if (i === 0) {
                    this.playerContainer.showPoints();
                    this.playerContainer.hidePosition();
                    this.playerContainer.hideScores();
                } else {
                    this.adversariesContainer[i - 1].showPoints();
                    this.adversariesContainer[i - 1].hidePosition();
                    this.adversariesContainer[i - 1].hideScores();
                }
            }, callbackScope: this});
        }

        // new hand
        this.scene.time.addEvent({ delay: 4000, callback: () => {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_5);
            GameVars.gameData.showTutorial = false;
            GameManager.writeGameData();
        }, callbackScope: this});
    }

    public newHand(): void {

        if (GameVars.removePlayer !== -1) {
            GameVars.numPlayers--;
            if (GameVars.removePlayer === 0) {
                BoardScene.currentInstance.endGame(GameConstants.END_LOSE);
                return;
            } else {
                this.adversariesContainer[GameVars.removePlayer - 1].removePlayer();
            }
        }

        if (GameVars.numPlayers === 1) {
            BoardScene.currentInstance.endGame(GameConstants.END_WIN);
            return;
        }

        GameVars.removePlayer = -1;
        
        this.bringToTop(this.bus);
        this.bringToTop(this.deckContainer);
        BoardManager.allCardsToDeck();
    }

    public allCardsToDeck(): void {

        this.deckContainer.allCardsToDeck();

        for  (let i = 0; i < this.adversariesContainer.length; i++) {
            if (GameVars.players[i + 1].tokens > 0) {
                this.adversariesContainer[i].resetAI();
            }
        } 

        this.playerContainer.resetAI();
    }

    public addCardToPlayerAI(): void {

        for  (let i = 0; i < this.adversariesContainer.length; i++) {
            if (GameVars.players[i + 1].tokens > 0) {
                this.adversariesContainer[i].addCardToPlayerAI();
            }
        } 

        this.playerContainer.addCardToPlayerAI();
    }

    public removeCardToPlayerAI(card: CardValue): void {

        for  (let i = 0; i < this.adversariesContainer.length; i++) {
            if (GameVars.players[i + 1].tokens > 0) {
                this.adversariesContainer[i].removeCardToPlayerAI(card);
            }
        } 

        this.playerContainer.removeCardToPlayerAI(card);
    }

    public selectDeckOrWasteAI(): string {

        if (GameVars.currentTurn === 0) {
            return this.playerContainer.selectDeckOrWasteAI();
        } else {
            return this.adversariesContainer[GameVars.currentTurn - 1].selectDeckOrWasteAI();
        }
        
    }

    public selectCardAndStopAI(): {card: number, stop: boolean} {

        if (GameVars.currentTurn === 0) {
            return this.playerContainer.selectCardAndStopAI();
        } else {
            return this.adversariesContainer[GameVars.currentTurn - 1].selectCardAndStopAI();
        }
        
    }
}
